module.exports = __webpack_public_path__ + "static/media/modal-clause.4050f7e2.png";